<template>
	<div>
		<div class="row">
			<div class="col-xl-12">
				<comparison-card title="COMPARISON SITES"></comparison-card>
			</div>
		</div>

	</div>
</template>

<script>
import { ComparisonCard } from '@/components/index';
export default {
	name: 'comparison',
	components: {
		ComparisonCard
	}
}
</script>

<style scoped>

</style>
